import { ChatAttachmentService } from '@agent/agent-interface/contact-view/chat/services/chat-attachment.service';
import { ChatContactBuilderService } from '@agent/agent-interface/contact-view/chat/services/chat-contact-builder.service';
import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { ScreenSharingService } from '@agent/agent-interface/contact-view/chat/services/screen-sharing.service';
import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { finalize, tap } from 'rxjs';

import { CngAgentEffect } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class ChatEffect extends CngAgentEffect {
  /**
   * Initialize effect
   */
  readonly init$ = createEffect(
    () =>
      this.onInitEffects$.pipe(
        tap(() => {
          this.chatContactBuilderService.init();
          this.chatScreenSharingService.init();
          this.chatAttachment.init();
          this.chatSocketService.init();
        }),
        finalize(() => {
          this.chatContactBuilderService.destroy();
          this.chatScreenSharingService.destroy();
          this.chatAttachment.destroy();
          this.chatSocketService.destroy();
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly chatSocketService: ChatSocketService,
    private readonly chatScreenSharingService: ScreenSharingService,
    private readonly chatAttachment: ChatAttachmentService,
    private readonly chatContactBuilderService: ChatContactBuilderService
  ) {
    super();
  }
}
